
<div class="title">
  {{title}}
</div>

<app-highcharts
            [options]="optionsChart"
            [showValue]="true"
            [defaultChart]="true"
></app-highcharts>
